import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Home from "@/components/Home.vue";
import DisplayPage from "@/components/DisplayPage.vue";
import FirmManagement from "@/components/FirmManagement.vue";
import User from "@/components/User.vue";
import AllleaderBoard from "@/components/AllleaderBoard";
import CountHistory from "@/components/CountHistory";
import PriceHistory from "@/components/PriceHistory";
import NewlyIncreased from "@/components/firmOffer/NewlyIncreased";
import PrivaTeLetter from "@/components/PrivaTeLetter";
import Question from "@/components/Question";
import PersonalSpot from "@/components/spotGoods/personalSpot";
import IndividualOption from "@/components/individualOption/IndividualOption";
import Course from "@/components/course/course";
import store from "@/store"
Vue.use(Router)
let routes = [
  {
    path: '/',
    name: 'index',
    component: Index,
    children: [
      {
        path: "/Home", name: "Home", component: Home, meta: {
          showNavMenu: true
        }
      },
      {
        path: "/", redirect: "/Home"
      },
      { path: "/PrivaTeLetter", name: "私信", component: PrivaTeLetter },
      { path: "/AllleaderBoard", name: "全部排行榜", component: AllleaderBoard },
      // { path: "/DisplayPage", name: "展示页", component: DisplayPage },
      { path: "/User", name: "个人期货数据", component: User },
      { path: "/PersonalSpot", name: "个人现货数据", component: PersonalSpot },
      { path: "/IndividualOption", name: "个人期权数据", component: IndividualOption },


      { path: "/CountHistory", name: "实盘人数多空比历史记录", component: CountHistory },
      { path: "/PriceHistory", name: "实盘金额多空比历史记录", component: PriceHistory },
      { path: "/FirmManagement", name: "实盘管理", component: FirmManagement },
      { path: "/NewlyIncreased", name: "新增实盘", component: NewlyIncreased },
      { path: "/Course", name: "问题反馈", component: Course },
      { path: "/Question", name: "问题反馈", component: Question },
    ]
  },
  {
    path: '/kLine',
    name: 'k线展示',
    component: () => import(/* webpackChunkName: "about" */ '../components/K/k-line.vue')
  },
  {
    path: '/backStage',
    name: '牛回速归后台管理',
    component: () => import(/* webpackChunkName: "about" */ '../components/K/back-stage.vue')
  },
]

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, resolve, reject) {
  if (resolve || reject) return originalPush.call(this, location, resolve, reject)
  return originalPush.call(this, location).catch((e) => { })
}

let router = new Router({
  routes
})

//EventBus 事件总线
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  if (!token && to.name !== "Home") {
    // 监听接收登录消息
    Vue.prototype.$EventBus.$emit('changedialogFormVisible')
    router.push('/Home')
  } else {
    next();
  }
})


export default router;


// export default new Router({
//   routes: [
//     {
//       path: '/',
//       name: 'index',
//       component: Index,
//       children: [
//         {
//           path: "/Home", name: "首页", component: Home, meta: {
//             showNavMenu: true
//           }
//         },
//         {
//           path: "/", redirect: "/Home"
//         },
//         { path: "/PrivaTeLetter", name: "私信", component: PrivaTeLetter },
//         { path: "/User", name: "用户页面", component: User },
//         { path: "/AllleaderBoard", name: "全部排行榜", component: AllleaderBoard },
//         // { path: "/DisplayPage", name: "展示页", component: DisplayPage },
//         { path: "/User", name: "展示页", component: User,meta:{auth:true}},
//         { path: "/CountHistory", name: "实盘人数多空比历史记录", component: CountHistory },
//         { path: "/PriceHistory", name: "实盘金额多空比历史记录", component: PriceHistory },
//         { path: "/FirmManagement", name: "实盘管理", component: FirmManagement },
//         { path: "/NewlyIncreased", name: "新增实盘", component: NewlyIncreased },
//       ]
//     }
//   ]
// })






// WEBPACK FOOTER //
// ./src/router/index.js